import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import api from '../middleware/api';
import rootReducer from './index.reducer';

const configureStore = preloadedState => createStore(rootReducer, preloadedState, applyMiddleware(thunk, api));

export default configureStore;
